import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from 'axios';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';

const API_URL = 'https://pdks.bytebridge.com.tr/api/departments';

function Departments() {
  const [departments, setDepartments] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [departmentName, setDepartmentName] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    fetchDepartments();
  }, []);

  const fetchDepartments = async () => {
    try {
      const res = await axios.get(API_URL);
      setDepartments(res.data);
    } catch (error) {
      setDepartments([]);
    }
  };

  const handleOpenDialog = (department = null) => {
    setEditMode(!!department);
    setSelectedDepartment(department);
    setDepartmentName(department ? department.DepartmentName : '');
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setEditMode(false);
    setDepartmentName('');
    setSelectedDepartment(null);
  };

  const handleSave = async () => {
    try {
      if (editMode && selectedDepartment) {
        await axios.put(`${API_URL}/${selectedDepartment.ID}`, { DepartmentName: departmentName });
      } else {
        await axios.post(API_URL, { DepartmentName: departmentName });
      }
      fetchDepartments();
      handleCloseDialog();
    } catch (error) {
      // Hata yönetimi
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${API_URL}/${id}`);
      fetchDepartments();
    } catch (error) {
      // Hata yönetimi
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Box sx={{ p: 3 }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
        <Tooltip title="Departmanları bu sayfadan yönetebilirsiniz.">
          <InfoOutlinedIcon color="primary" style={{ marginRight: 8, cursor: 'pointer' }} />
        </Tooltip>
        <Typography variant="h4" gutterBottom>Departmanlar</Typography>
      </div>
      <Button variant="contained" color="primary" onClick={() => handleOpenDialog()}>Departman Ekle</Button>
      <TableContainer component={Paper} sx={{ mt: 3 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Departman Adı</TableCell>
              <TableCell align="right">İşlemler</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {departments.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((department) => (
              <TableRow key={department.ID}>
                <TableCell>{department.ID}</TableCell>
                <TableCell>{department.DepartmentName}</TableCell>
                <TableCell align="right">
                  <IconButton color="primary" onClick={() => handleOpenDialog(department)}><EditIcon /></IconButton>
                  <IconButton color="error" onClick={() => handleDelete(department.ID)}><DeleteIcon /></IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={departments.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>{editMode ? 'Departman Güncelle' : 'Departman Ekle'}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Departman Adı"
            fullWidth
            value={departmentName}
            onChange={e => setDepartmentName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>İptal</Button>
          <Button onClick={handleSave} variant="contained" color="primary">Kaydet</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default Departments;
